import { Box } from '@mui/material';
import { TabPanel } from '@mui/lab';
import React from 'react';
import ChargesKM from 'views/orders/charges-accounting/charges-km/charges-km';

export const ChargesKMTabContent = () => {
  return (
    <TabPanel value="K-M" style={{ padding: '16px', marginTop: '1rem' }}>
      <Box>
        <ChargesKM showHeaderAndContainer={false} />
      </Box>
    </TabPanel>
  );
};
